import { all, call, put, takeLatest } from 'redux-saga/effects';
import { basketOperations, basketTypes } from '../../store/basket';

import { DAS_ADD_EXTRAS_TO_BASKET_FAILED } from '../../constants/errors';
import { addAccommodationExtraToBasket } from '../../api/basket';
import { createError } from '../../store/errors';
import { messageOperations } from '../../store/messages';
import { reloadBasket } from './helpers';

const { ADD_ACCOMMODATION_EXTRAS_TO_BASKET } = basketTypes;
const { sendMessage } = messageOperations;

export const performAddAccommodationExtrasToBasket = function* performAddAccommodationExtrasToBasket({
  payload,
}) {
  const {
    addAccommodationExtrasToBasketSuccess,
    addToBasketFailed,
  } = basketOperations;

  try {
    const addToBasketResponse = yield call(
      addAccommodationExtraToBasket,
      payload.bookingRef,
      payload.extras,
    );

    if (addToBasketResponse.errors) {
      // Handle web service errors.
      yield all(
        addToBasketResponse.errors.map(error => put(createError(error))),
      );

      yield put(addToBasketFailed());
      return;
    }

    const basketResponse = yield call(reloadBasket, payload.bookingRef);
    if (basketResponse.errors) {
      return;
    }

    const { extras } = payload;

    yield put(addAccommodationExtrasToBasketSuccess());

    yield put(
      sendMessage({
        type: 'success',
        displayType: 'toast',
        message: `Your accommodation ${
          extras.length > 1 ? 'options' : 'option'
        } ${extras.length > 1 ? 'were' : 'was'} added to your basket.`,
      }),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_ADD_EXTRAS_TO_BASKET_FAILED,
      }),
    );
    yield put(addToBasketFailed());
  }
};

export default takeLatest(
  ADD_ACCOMMODATION_EXTRAS_TO_BASKET,
  performAddAccommodationExtrasToBasket,
);
